import { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import { createManufacturers, updateManufacturers } from "../../../Utility/Api";
import { WarehouseContext } from '../../../Utility/UserContext';



export const EditManufacturers = ({ showModal, setShowModal, fetchManufacturers, selectedManufacturers, fetchdata, AddorEdit }) => {
    const { showLoader, hideLoader, shopItem, UserItem } = useContext(WarehouseContext);

    const [formData, setFormData] = useState({
        name: '',
        country: '',
        shop_id: shopItem?.shop_id || "0",
        created_by: UserItem?.user_id || "0",
        generate_response: ''

    });
    const [errors, setErrors] = useState({});


    useEffect(() => {


        setFormData({
            ...formData,
            name: selectedManufacturers?.name,
            shop_id: shopItem?.shop_id || "0",
            created_by: UserItem?.user_id || "0",
            country: selectedManufacturers?.country,
            generate_response: selectedManufacturers?.generate_response,

        });
    }, [selectedManufacturers])

    const handleSubmit = async (e) => {
        e.preventDefault();
        showLoader()
        const validationErrors = {};

        if (!formData.name) {
            validationErrors.name = "name  is required.";
        }

        if (!formData.country) {
            validationErrors.country = "country name  is required.";
        }

        if (Object.keys(validationErrors).length > 0) {
            hideLoader()
            setErrors(validationErrors);
            return;
        }

        const payload = {
            name: formData.name,
            country: formData.country,
            shop_id: shopItem?.shop_id || "0",
            created_by: UserItem?.user_id || "0",
            generate_response: formData.generate_response,
        };

        console.log('Payload being sent:', payload);
        try {
            if (AddorEdit) {
                await createManufacturers(JSON.stringify(payload));
                hideLoader()
                toast.success('Manufacturers Added successfully');
            } else {
                await updateManufacturers(selectedManufacturers?.manufacturer_id, payload);
                hideLoader()
                toast.success('Manufacturers Updated successfully');
            }
            setShowModal(false);
            fetchManufacturers();
            handlecancel();
        } catch (error) {
            console.error('Error Manufacturers data:', error);
            hideLoader()
            if (error.response?.data?.message) {
                toast.error(error.response?.data?.message);
            }
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
        setErrors((prev) => ({
            ...prev,
            [name]: "",
        }));
    };

    const handlecancel = () => {
        setShowModal(false)
        setErrors({
            name: '',
            country: '',
        })
        setFormData({
            name: '',
            country: '',
            generate_response: '',
            shop_id: shopItem?.shop_id || "0",
            created_by: UserItem?.user_id || "0",
        });

    }


    return (
        <>
            {showModal && (
                <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header border-0">
                                <h5 className="modal-title" >{selectedManufacturers ? 'Edit Manufacturers' : 'Add Manufacturers'}</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close"
                                    onClick={() => handlecancel()}
                                ></button>
                            </div>
                            <div className="modal-body" style={{ fontFamily: "poppins" }}>
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group mb-3 d-flex align-items-center">
                                        <label className="col-4 text-normal">Manufacturers</label>
                                        <div className="col-8">
                                            <input
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                className="form-control"

                                            />
                                            {errors.name && (
                                                <small className="text-danger mx-2">{errors.name}</small>
                                            )}
                                        </div>
                                    </div>


                                    <div className="form-group mb-3 d-flex align-items-center">
                                        <label className="col-4 text-normal">Country</label>
                                        <div className="col-8">
                                            <input
                                                type="text"
                                                name="country"
                                                value={formData.country}
                                                onChange={handleChange}
                                                className="form-control"

                                            />
                                            {errors.country && (
                                                <small className="text-danger mx-2">{errors.country}</small>
                                            )}
                                        </div>
                                    </div>


                                    <div className="mt-5">
                                        <button type="submit" className="btn btn-success float-end rounded-1 text-normal" style={{ fontFamily: "poppins" }}>
                                            {selectedManufacturers ? 'Update Manufacturers' : 'Add Manufacturers'}</button>
                                        &nbsp;
                                        <button
                                            type="button"
                                            className="btn btn-secondary ml-2 float-end me-1 rounded-1 text-normal"
                                            onClick={() => handlecancel()}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}</>
    )
}